import './CheckboxInput.scss';

import { Checkbox } from 'antd';
import type { RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { InputNoteConfig } from '../_common';
import {
  getHookFieldClass,
  getHookGroupClass,
  renderErrorMessage,
  renderHookInputNote,
  renderHookLabel
} from '../_common';

interface CheckboxInputProps {
  name: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  inputNote?: InputNoteConfig;
  options?: RegisterOptions;
  hideLabel?: boolean;
}

const CheckboxInput = ({
  name,
  disabled,
  inputNote,
  label,
  required,
  options,
  hideLabel
}: CheckboxInputProps) => {
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error, isTouched } = getFieldState(name, formState);

  const showError = !!error && isDirty;

  return (
    <div className={getHookGroupClass(label, 'CheckboxInput')}>
      <Controller
        name={name}
        control={control}
        rules={options}
        render={({ field }) => (
          <Checkbox
            {...field}
            id={name}
            disabled={disabled}
            className={getHookFieldClass(isTouched, invalid)}
            checked={!!field.value}
          >
            {!hideLabel && renderHookLabel(name, label, required)}
            {!hideLabel && renderHookInputNote(inputNote)}
          </Checkbox>
        )}
      />
      {renderErrorMessage(showError, error?.message)}
    </div>
  );
};

export default CheckboxInput;
